import { useState } from 'react';
import { User, UserFormData, RoleEnum } from '../../../types';

export const useUserForm = () => {
  const [open, setOpen] = useState(false);
  const [editingUser, setEditingUser] = useState<User | null>(null);
  const [formData, setFormData] = useState<UserFormData>({
    username: '',
    email: '',
    password: '',
    role: RoleEnum.STAFF,
    is_active: true,
    is_superuser: false,
    permissions: [],
  });
  const [error, setError] = useState<string | null>(null);

  const handleOpen = (user?: User) => {
    if (user) {
      setEditingUser(user);
      setFormData({
        username: user.username,
        email: user.email,
        password: '',
        role: user.role,
        is_active: user.is_active,
        is_superuser: user.is_superuser,
        permissions: user.permissions || [],
        profile_ids: user.access_profiles?.map((profile) => profile.id) || [],
      });
    } else {
      setEditingUser(null);
      setFormData({
        username: '',
        email: '',
        password: '',
        role: RoleEnum.STAFF,
        is_active: true,
        is_superuser: false,
        permissions: [],
        profile_ids: [],
      });
    }
    setOpen(true);
    setError(null);
  };

  const handleClose = () => {
    setOpen(false);
    setEditingUser(null);
    setError(null);
  };

  const validateForm = () => {
    if (!formData.email) {
      setError('Email обязателен');
      return false;
    }
    if (!isValidEmail(formData.email)) {
      setError('Введите корректный email');
      return false;
    }
    if (!formData.username) {
      setError('Логин обязателен');
      return false;
    }
    if (!editingUser && !formData.password) {
      setError('Пароль обязателен для нового пользователя');
      return false;
    }
    if (formData.password && formData.password.length < 8) {
      setError('Пароль должен содержать минимум 8 символов');
      return false;
    }
    return true;
  };

  const isValidEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  return {
    open,
    editingUser,
    formData,
    error,
    handleOpen,
    handleClose,
    validateForm,
    setFormData,
    setError,
  };
}; 
